import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import AuthContext from '@providers/context/componenets/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faCalendarAlt, faFileAlt, faChartLine } from '@fortawesome/free-solid-svg-icons';

export default function Home() {
    const { t } = useTranslation();
    const { userFullName } = useContext(AuthContext);

    return (
        <div className="home-container p-4">
            <div className="welcome-section mb-4">
                <h2 className="text-primary">{t('home.welcome')}, {userFullName}!</h2>
                <p className="text-muted">{t('home.welcomeMessage')}</p>
            </div>

            {/* <div className="quick-stats row g-4"> */}
            {/* <div className="col-md-3">
                    <div className="card h-100">
                        <div className="card-body">
                            <div className="d-flex align-items-center">
                                <div className="icon-circle bg-primary text-white me-3">
                                    <FontAwesomeIcon icon={faUsers} />
                                </div>
                                <div>
                                    <h6 className="card-title mb-0">{t('home.totalEmployees')}</h6>
                                    <h3 className="mb-0">0</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}

            {/* <div className="col-md-3">
                    <div className="card h-100">
                        <div className="card-body">
                            <div className="d-flex align-items-center">
                                <div className="icon-circle bg-success text-white me-3">
                                    <FontAwesomeIcon icon={faCalendarAlt} />
                                </div>
                                <div>
                                    <h6 className="card-title mb-0">{t('home.upcomingEvents')}</h6>
                                    <h3 className="mb-0">0</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}

            {/* <div className="col-md-3">
                    <div className="card h-100">
                        <div className="card-body">
                            <div className="d-flex align-items-center">
                                <div className="icon-circle bg-info text-white me-3">
                                    <FontAwesomeIcon icon={faFileAlt} />
                                </div>
                                <div>
                                    <h6 className="card-title mb-0">{t('home.pendingDocuments')}</h6>
                                    <h3 className="mb-0">0</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}

            {/* <div className="col-md-3">
                    <div className="card h-100">
                        <div className="card-body">
                            <div className="d-flex align-items-center">
                                <div className="icon-circle bg-warning text-white me-3">
                                    <FontAwesomeIcon icon={faChartLine} />
                                </div>
                                <div>
                                    <h6 className="card-title mb-0">{t('home.activeProjects')}</h6>
                                    <h3 className="mb-0">0</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
            {/* </div> */}

            <style jsx>{`
                .home-container {
                    max-width: 1200px;
                    margin: 0 auto;
                }
                .icon-circle {
                    width: 48px;
                    height: 48px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 1.2rem;
                }
                .card {
                    transition: transform 0.2s;
                    border: none;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
                }
                .card:hover {
                    transform: translateY(-5px);
                }
                .welcome-section {
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-end;
                    align-items: flex-end;
                    background: linear-gradient(to right, #f8f9fa, #ffffff);
                    padding: 2rem;
                    border-radius: 10px;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
                    margin-left:200px;
                }
            `}</style>
        </div>
    );
}